import { inject, Injectable } from "@angular/core";
import { RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { TUserData } from "./utilities/types";
import Keycloak from "keycloak-js";

@Injectable({
  providedIn: "root",
})
export class UserDataResolver {
  private keycloak = inject(Keycloak);
  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<TUserData | undefined> {
    return this.keycloak.loadUserProfile();
  }
}
